module.exports = __webpack_public_path__ + "img/pc-user2.18e4dfa7.svg";